function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#5d56c1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29.45 58.3L15.47 45.99l3.96-4.51 9.69 8.54L56.5 21.75l4.31 4.18z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39 78a39 39 0 1139-39 39.05 39.05 0 01-39 39zm0-72a33 33 0 1033 33A33 33 0 0039 6z"
}));

function SvgIconCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 78 78"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNzggNzgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzVkNTZjMSI+PHBhdGggZD0ibTI5LjQ1IDU4LjMtMTMuOTgtMTIuMzEgMy45Ni00LjUxIDkuNjkgOC41NCAyNy4zOC0yOC4yNyA0LjMxIDQuMTh6Ii8+PHBhdGggZD0ibTM5IDc4YTM5IDM5IDAgMSAxIDM5LTM5IDM5LjA1IDM5LjA1IDAgMCAxIC0zOSAzOXptMC03MmEzMyAzMyAwIDEgMCAzMyAzMyAzMyAzMyAwIDAgMCAtMzMtMzN6Ii8+PC9nPjwvc3ZnPg==";
export { SvgIconCheckmark as ReactComponent };